import { render } from "./SubscriptionProducts.vue?vue&type=template&id=67a97110&ts=true"
import script from "./SubscriptionProducts.vue?vue&type=script&lang=ts"
export * from "./SubscriptionProducts.vue?vue&type=script&lang=ts"

import "./SubscriptionProducts.vue?vue&type=style&index=0&id=67a97110&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__